"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = exports.hideAllContextMenus = exports.showContextMenu = exports.contextMenuTheme = exports.contextMenuAnimation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
var react_contexify_1 = require("react-contexify");
Object.defineProperty(exports, "contextMenuAnimation", { enumerable: true, get: function () { return react_contexify_1.animation; } });
Object.defineProperty(exports, "contextMenuTheme", { enumerable: true, get: function () { return react_contexify_1.theme; } });
const react_contexify_2 = require("react-contexify");
const MenuItem_1 = require("./MenuItem");
const ContextSubMenu_1 = require("./ContextSubMenu");
const lib_1 = require("../../lib");
const ContextMenuContext_1 = require("./ContextMenuContext");
const MenuSectionTitle_1 = require("./MenuSectionTitle");
const Portal_1 = require("../Portal");
exports.showContextMenu = react_contexify_2.contextMenu === null || react_contexify_2.contextMenu === void 0 ? void 0 : react_contexify_2.contextMenu.show;
exports.hideAllContextMenus = react_contexify_2.contextMenu === null || react_contexify_2.contextMenu === void 0 ? void 0 : react_contexify_2.contextMenu.hideAll;
class ContextMenu extends react_1.Component {
    constructor() {
        super(...arguments);
        this.menu = (0, react_1.createRef)();
        this.handleClickEvent = (event) => {
            const domNode = (0, react_dom_1.findDOMNode)(this.menu.current);
            if (domNode && !domNode.contains(event.target)) {
                if (this.props.onClickOutside)
                    this.props.onClickOutside();
                if (this.props.onClose)
                    this.props.onClose();
            }
            else {
                if (this.props.onClick)
                    this.props.onClick();
            }
        };
        this.onItemClick = () => {
            if (this.props.onClose)
                this.props.onClose();
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.event && prevProps.event !== this.props.event) {
            window.requestAnimationFrame(() => (0, exports.showContextMenu)({ id: this.props.id, event: this.props.event }));
        }
    }
    componentDidMount() {
        if (this.props.event) {
            window.requestAnimationFrame(() => (0, exports.showContextMenu)({ id: this.props.id, event: this.props.event }));
        }
        document.addEventListener("mousedown", this.handleClickEvent);
    }
    componentWillUnmount() {
        window.removeEventListener("mousedown", this.handleClickEvent);
    }
    render() {
        return ((0, jsx_runtime_1.jsx)(ContextMenuContext_1.ContextMenuContext.Provider, Object.assign({ value: { onItemClick: this.onItemClick } }, { children: (0, jsx_runtime_1.jsx)(Portal_1.Portal, { children: (0, jsx_runtime_1.jsx)(react_contexify_2.Menu, Object.assign({}, this.props, { className: (0, lib_1.classnames)(this.props.className, "context-menu") }, { ref: this.menu }, { preventDefaultOnKeydown: false }), void 0) }, void 0) }), void 0));
    }
}
exports.ContextMenu = ContextMenu;
ContextMenu.Item = MenuItem_1.MenuItem;
ContextMenu.Separator = react_contexify_2.Separator;
ContextMenu.Submenu = ContextSubMenu_1.ContextSubMenu;
ContextMenu.SectionTitle = MenuSectionTitle_1.MenuSectionTitle;
//# sourceMappingURL=ContextMenu.js.map